import type { MutableRefObject } from 'react'

type ResolveSessionStepSyncPolicyArgs = {
  currentStep: number
  suppressNextSessionStepSyncRef: MutableRefObject<boolean>
  sessionStepSyncLockRef: MutableRefObject<number | null>
}

export function resolveSessionStepSyncPolicy({
  currentStep,
  suppressNextSessionStepSyncRef,
  sessionStepSyncLockRef
}: ResolveSessionStepSyncPolicyArgs) {
  const lockedStep = sessionStepSyncLockRef.current
  const isStepSyncLocked = typeof lockedStep === 'number' && currentStep <= lockedStep
  const shouldSyncStep = !suppressNextSessionStepSyncRef.current && !isStepSyncLocked

  if (typeof lockedStep === 'number' && currentStep > lockedStep) {
    sessionStepSyncLockRef.current = null
  }

  suppressNextSessionStepSyncRef.current = false

  return {
    shouldSyncStep
  }
}
